import React, { useState } from 'react'
import { TtButton, TtTooltip } from '@23/react'

import './Forewarn.scss'

let peristantDismissed = false

const Forewarn = () => {
  const [wasDismissed, setWasDismissed] = useState(peristantDismissed)

  if (!navigator.userAgent.includes('Firefox/138')) return null

  if (wasDismissed) return null

  return (
    <div className="forewarn">
      <div className="forewarn-notice">
        <p>
          We have identified a potential performance problem on{' '}
          <b>version&nbsp;138</b> of <b>Firefox</b> which can cause video tracks
          to not display properly in the webinar room.
        </p>

        <p>
          If you can, we recommend switching to a{' '}
          <TtTooltip placement="top">
            <span className="tooltip-trigger">different browser</span>
            <span slot="content" className="tooltip-content">
              We recommend using either
              <br />
              Chrome, Edge or Safari
            </span>
          </TtTooltip>{' '}
          while this is being resolved. We apologise for the inconvenience.
        </p>
        <p>
          Read more details at{' '}
          <a
            target="_blank"
            href="https://www.twentythree.com/firefox138"
            rel="noreferrer"
          >
            twentythree.com/firefox138
          </a>
          .
        </p>

        <TtButton
          size="small"
          pill
          onClick={() => {
            peristantDismissed = true
            setWasDismissed(true)
          }}
        >
          I understand
        </TtButton>
      </div>
    </div>
  )
}

export { Forewarn }
